/**
 * @module
 * @category Component
 */

import 'BomdisoftComponents/section/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import type { CSSProperties, ReactNode } from 'react';

interface SectionProps {
  children: ReactNode;
  isHeader?: boolean;
  centered?: boolean;
  customStyle?: CSSProperties;
  className?: string;
}

export const Section = ({ children, isHeader = false, centered = false, customStyle, className }: SectionProps) => (
  <section className={joinClasses('bomdisoft-section', className)} data-centered={centered ? '' : undefined} data-header={isHeader ? '' : undefined} style={customStyle}>
    {children}
  </section>
);
